<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="warehouse.pkid ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :rules="ruleValidate" :model="warehouse" label-width="80px">
      <!--      <div v-if="warehouse.level === 3">-->
      <!--        <el-form-item label="行号" prop="lineNo">-->
      <!--          <el-input v-model="warehouse.lineNo" placeholder="请输入行号"/>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="列号" prop="columnNo">-->
      <!--          <el-input v-model="warehouse.columnNo" placeholder="请输入列号"/>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="层号" prop="tierNo">-->
      <!--          <el-input v-model="warehouse.tierNo" placeholder="请输入层号"/>-->
      <!--        </el-form-item>-->
      <!--      </div>-->
      <el-form-item v-if="warehouse.pkid" label="编码">
        <el-input v-model="warehouse.code" disabled/>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="warehouse.name" placeholder="请输入名称"/>
      </el-form-item>
      <el-form-item label="外部编号" prop="outerCode">
        <el-input v-model="warehouse.outerCode" placeholder="请输入外部编号"/>
      </el-form-item>
      <el-form-item label="层级">
        <el-input v-model="warehouse.level" disabled/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        warehouse: {
          pkid: 0,
          code: "",
          name: "",
          level: 1,
          outerCode: "",
          parentId: "",
          lineNo: "",
          columnNo: "",
          tierNo: "",
        },
        ruleValidate: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          // lineNo: [{required: true, message: "请输入行号", trigger: "blur"}],
          // columnNo: [{required: true, message: "请输入列号", trigger: "blur"}],
          // tierNo: [{required: true, message: "请输入层号", trigger: "blur"}],
        },
        submitLoading: false,
      };
    },

    methods: {
      open(mark, row) {
        this.dialogVisible = true;
        if (!mark) {
          // 编号不赋初始值
          // if (!row) {
          //   this.getCode(1);
          // } else if (row.level === 1) {
          //   this.getCode(2, row.id);
          // }
          this.warehouse.level = row ? row.level + 1 : 1;
          this.warehouse.parentId = row ? row.id : null;
        } else {
          this.warehouse = Object.assign(this.warehouse, row);
          this.warehouse.name = row.label;
          this.warehouse.code = row.other;
          this.warehouse.outerCode = row.other2;
          this.warehouse.pkid = row.id;
          // if (this.warehouse.level === 3) {
          //   let temp = this.warehouse.code.split("-");
          //   this.warehouse.lineNo = temp[1];
          //   this.warehouse.columnNo = temp[2];
          //   this.warehouse.tierNo = temp[3];
          // }
        }
      },

      getCode(level, parentId, id) {
        let params = {
          level: level,
          pkid: id || -1,
          parentId: parentId || -1,
          isSave: 0,
        };
        this.$http.get("basic", "warehouses/getCode", params).then((resp) => {
          if (resp.success) {
            this.warehouse.code = resp.data.code;
            this.warehouse.lineNo = resp.data.lineNo;
            this.warehouse.columnNo = resp.data.columnNo;
            this.warehouse.tierNo = resp.data.tierNo;
          }
        });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "warehouses", this.warehouse)
              .then((res) => {
                if (res.success) {
                  this.$emit("save-success");
                  if (!this.warehouse.pkid) {
                    this.$message.success("添加成功");
                  } else {
                    this.$message.success("编辑成功");
                  }
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
